import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import { FaWater, FaChartBar, FaInfoCircle } from "react-icons/fa";

import "./WaterReport4.css";

const tributaryData = [
  { name: "Bear River", value: 60 },
  { name: "Weber River", value: 20 },
  { name: "Jordan River", value: 15 },
  { name: "Other", value: 5 },
];

const WaterReport4 = () => {
  return (
    <div className="report-wrapper">
      {/* HEADER */}
      <div className="report-header">
        <h1>
          <FaWater /> Impact of Residential Water Savings on Great Salt Lake
        </h1>
        <p>
          Water saved from residential usage directly contributes to sustaining
          the Great Salt Lake. Since the lake has no outlet, inflows from rivers
          determine its survival.
        </p>
      </div>

      {/* TRIBUTARY TABLE */}
      <div className="section-card">
        <h3>
          <FaWater /> Primary Tributaries
        </h3>

        <table className="clean-table">
          <thead>
            <tr>
              <th style={{ color: "#6894eb" }}>Tributary</th>
              <th style={{ color: "#6894eb" }}>Contribution</th>
              <th style={{ color: "#6894eb" }}>Snowpack</th>
              <th style={{ color: "#6894eb" }}>Flow</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Bear River</td>
              <td>60%</td>
              <td>79% – 104%</td>
              <td>880 cfs</td>
            </tr>
            <tr>
              <td>Weber River</td>
              <td>20%</td>
              <td>49% – 71%</td>
              <td>50 cfs</td>
            </tr>
            <tr>
              <td>Jordan River</td>
              <td>15%</td>
              <td>43% – 68%</td>
              <td>150 cfs</td>
            </tr>
            <tr>
              <td>Other</td>
              <td>5%</td>
              <td>-</td>
              <td>Varies</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* CHART */}
      <div className="section-card">
        <h3>
          <FaChartBar /> Contribution to Lake Inflow
        </h3>

        <ResponsiveContainer width="100%" height={360}>
          <BarChart
            data={tributaryData}
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" opacity={0.1} />

            <XAxis
              dataKey="name"
              label={{
                value: "Tributary",
                position: "insideBottom",
                offset: -10,
                style: { fill: "#555" },
              }}
            />

            <YAxis
              label={{
                value: "Contribution (%)",
                angle: -90,
                position: "insideLeft",
                dx: 0,
                dy: 20,
                style: { fill: "#555", textAnchor: "middle" },
              }}
            />

            <Tooltip formatter={(value) => `${value}%`} />

            <Bar dataKey="value" fill="#38bdf8" radius={[10, 10, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* STRATEGIC IMPORTANCE */}
      <div className="section-card">
        <h3>
          <FaInfoCircle /> Strategic Importance
        </h3>

        <div className="importance-grid">
          <div className="importance-card">
            <h4>Bear River (Major Source)</h4>
            <p>
              Largest contributor. Conservation here directly impacts lake
              levels and supports migratory bird habitats.
            </p>
          </div>

          <div className="importance-card">
            <h4>Weber River (Ecological Balance)</h4>
            <p>
              Supports wetlands and bird ecosystems. Critical for maintaining
              brackish marsh environments.
            </p>
          </div>

          <div className="importance-card">
            <h4>Jordan River (Urban Link)</h4>
            <p>
              Carries recycled urban water back to the lake, playing a key role
              in sustaining the ecosystem.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaterReport4;
